import React from 'react'

import { useAppSelector } from 'reduxTyped'
import { contentManagementSelectors } from 'apps/cms/store'
import { isExternalFlowOrigin } from 'common/flow/flowOrigin'

import { ClassicFlowCompactCard } from './ClassicFlowCompactCard'
import { ExternalFlowCompactCard } from './ExternalFlowCompactCard'

interface FlowCompactCardProps {
  flowId: string
}

export const FlowCompactCard = ({ flowId }: FlowCompactCardProps) => {
  const flow = useAppSelector(contentManagementSelectors.getFlows).find(
    (item) => item.ns === flowId,
  )

  if (!flow) {
    return null
  }

  return isExternalFlowOrigin(flow.origin) ? (
    <ExternalFlowCompactCard flow={flow} />
  ) : (
    <ClassicFlowCompactCard flow={flow} />
  )
}
